/** @jsxImportSource @emotion/react */
import { KeyboardEvent, MouseEvent } from 'react';
import { Link } from 'react-router-dom';

import { useAuth } from '@omnigenbiodata/ui';
import Drawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import { useTranslation } from 'react-i18next';
import { RiHome2Line, RiArrowDropRightFill, RiLogoutBoxLine, RiCloseLine } from 'react-icons/ri';
import { useStyles } from './component.styles';
import ROUTES from '../../../core/constants/routes.constants';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';

interface SideMenuProps {
  isOpen: boolean;
  onToggle: (open: boolean) => (event: MouseEvent | KeyboardEvent) => void;
}

function SideMenu({ isOpen, onToggle }: SideMenuProps) {
  const { t } = useTranslation('portal');
  const { signOut } = useAuth();
  const classes = useStyles();
  return (
    <>
      <Drawer anchor="right" open={isOpen} onClose={onToggle(false)} data-testid="menu-drawer">
        <Box css={classes.drawer} role="presentation" onClick={onToggle(false)} onKeyDown={onToggle(false)}>
          <Toolbar disableGutters css={classes.toolbar}>
            <IconButton
              onClick={() => {
                onToggle(true);
              }}
              edge="end"
              data-testid="menu-close-btn"
            >
              <RiCloseLine />
            </IconButton>
          </Toolbar>
          <List>
            <ListItem
              data-testid="nav-item-home"
              button
              key={t('navigation.home') as string}
              component={Link}
              onClick={() => {
                onToggle(false);
              }}
              to={ROUTES.root}
            >
              <ListItemIcon css={classes.iconWrapper}>
                <RiHome2Line fontSize="inherit" css={classes.icon} />
              </ListItemIcon>
              <ListItemText primary={t('navigation.home')} />
            </ListItem>

            <ListItem
              data-testid="nav-faq"
              button
              key={t('navigation.participants') as string}
              component={Link}
              onClick={() => {
                onToggle(false);
              }}
              to={ROUTES.root}
            >
              <ListItemIcon css={classes.iconWrapper}>
                <RiArrowDropRightFill fontSize="inherit" css={classes.icon} />
              </ListItemIcon>
              <ListItemText primary={t('navigation.participants')} />
            </ListItem>

            <ListItem
              data-testid="nav-faq"
              button
              key={t('navigation.sites') as string}
              component={Link}
              onClick={() => {
                onToggle(false);
              }}
              to={ROUTES.root}
            >
              <ListItemIcon css={classes.iconWrapper}>
                <RiArrowDropRightFill fontSize="inherit" css={classes.icon} />
              </ListItemIcon>
              <ListItemText primary={t('navigation.sites')} />
            </ListItem>

            <ListItem
              data-testid="nav-faq"
              button
              key={t('navigation.users') as string}
              component={Link}
              onClick={() => {
                onToggle(false);
              }}
              to={ROUTES.root}
            >
              <ListItemIcon css={classes.iconWrapper}>
                <RiArrowDropRightFill fontSize="inherit" css={classes.icon} />
              </ListItemIcon>
              <ListItemText primary={t('navigation.users')} />
            </ListItem>
          </List>
          <Divider />
          <List>
            <ListItem
              data-testid="nav-logout"
              button
              key={t('navigation.logout') as string}
              component={'button'}
              onClick={(event: MouseEvent) => {
                signOut();
                event.preventDefault();
              }}
            >
              <ListItemIcon css={classes.iconWrapper}>
                <RiLogoutBoxLine fontSize="inherit" css={classes.icon} />
              </ListItemIcon>
              <ListItemText primary={t('navigation.logout') as string} />
            </ListItem>
          </List>
        </Box>
      </Drawer>
    </>
  );
}

export default SideMenu;
